import { Button, Container, Form, Table, Modal } from 'react-bootstrap';
import { GoDiffAdded, GoTrashcan } from 'react-icons/go';

import styles from './MateriaisLimpeza.module.css';

const MateriaisLimpeza = props => {
  return (
    <Container className={styles.container_medicamentos}>
      <Table responsive striped bordered hover variant="dark">
        <thead>
          <tr>
            <th style={{ width: '55%' }}>Materiais de Limpeza</th>
            <th style={{ width: '15%' }}>Qtde</th>
            <th style={{ width: '30%' }}>Ação</th>
          </tr>
        </thead>

        <tbody>
          {props.materiaisLimpeza.map((item, index) => {
            return (
              <tr key={`${item.nome}-${index}`}>
                <td>
                  <Form.Group controlId="material">
                    <Form.Select
                      required
                      name="material"
                      onChange={e => props.handleMateriaisLimpeza(index, 'material', e.target.value)}
                      value={props.materiaisLimpeza[index].material}
                    >
                      <option value=""></option>
                      {props.listaMateriaisLimpeza.map(item => (
                        <option key={item.id} value={item.nome}>{item.nome}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </td>
                <td>
                  <Form.Group controlId="quantidade">
                    <Form.Control
                      autoComplete="new-off"
                      required
                      type="number"
                      step="1"
                      name="quantidade"
                      onChange={e => props.handleMateriaisLimpeza(index, 'quantidade', e.target.value)}
                      value={props.materiaisLimpeza[index].quantidade}
                    />
                  </Form.Group>
                </td>
                <td>
                  <div className={styles.container_buttons}>
                    <Button
                      variant="warning"
                      id="deleteTableRow"
                      onClick={e => props.handleRemoveMateriaisLimpeza(index)}
                    >
                      <div className={styles.icon_container}>
                        <GoTrashcan className={styles.icon_trash} />Excluir
                      </div>
                    </Button>

                    <Button
                      variant="flat"
                      id="addTableRow"
                      onClick={props.handleAddMateriaisLimpeza}
                      className={styles.btn}
                    >
                      <div className={styles.icon_container}>
                        <GoDiffAdded className={styles.icon_trash} />Incluir
                      </div>
                    </Button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>

        <tfoot>
          <tr>
            {props.materiaisLimpeza.length <= 0 && (
              <td colSpan="6">
                <div className="text-center">
                  <Button
                    variant="flat" className={styles.btn}
                    style={{ padding: '0 16px 0 16px' }}
                    id="addTableRow"
                    onClick={props.handleAddMateriaisLimpeza}
                  >
                    <GoDiffAdded className={styles.icon_trash} />Incluir
                  </Button>
                </div>
              </td>
            )}
          </tr>
        </tfoot>
      </Table>
      <Modal show={props.showModal} onHide={props.handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Erro</Modal.Title>
        </Modal.Header>
        <Modal.Body>{props.materialError}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.handleModalClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default MateriaisLimpeza;
